import {createContext} from 'react';

export const FlagImagesContext = createContext<{
  getFlagImageSource: (countryCode: string, regionCode?: string) => string;
  loading: boolean;
} | null>(null);
